import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Card, List } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';

// Global Components
import MyTimesheetEntriesDayTotal from 'components/MyTimesheetEntriesDayTotal';
import SemiBold from 'components/SemiBold';

// Global Selectors
import { makeSelectQueryStringNumberValue } from 'workspaces/react-router-selectors';

interface ConnectedProps {
    dayOfWeek?: number;
}

type Props = ConnectedProps;

export class MyTimesheetEntriesDailyTotalCard extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { dayOfWeek = 0 } = this.props;

        return (
            <Card fluid>
                <Card.Content>
                    <List.Item>
                        <List.Content floated="right">
                            <MyTimesheetEntriesDayTotal dayOfWeek={dayOfWeek} />
                        </List.Content>
                        <List.Content>
                            <SemiBold>DAILY TOTAL</SemiBold>
                        </List.Content>
                    </List.Item>
                </Card.Content>
            </Card>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    dayOfWeek: makeSelectQueryStringNumberValue('dayOfWeek')
});

export default connect(mapStateToProps)(MyTimesheetEntriesDailyTotalCard);
